"use client";
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _tagged_template_literal(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  width: 100%;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  width: 100%;\n"
    ]);
    _templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _tagged_template_literal([
        "\n  margin-right: 12px;\n  flex-shrink: 0;\n"
    ]);
    _templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _tagged_template_literal([
        "\n  width: 100%;\n  position: relative;\n"
    ]);
    _templateObject3 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _tagged_template_literal([
        "\n  width: 100%;\n  background-color: transparent;\n  color: var(--theme-text-primary, #14171a);\n  &::placeholder {\n    color: var(--theme-text-secondary, #657786);\n  }\n  outline: none;\n  resize: none;\n  margin-bottom: 0.5rem;\n  font-family: inherit;\n  font-size: 1rem;\n  line-height: 1.5;\n  border: 1px solid transparent;\n  border-radius: 0.5rem;\n  padding: 0.5rem;\n"
    ]);
    _templateObject4 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-top: 0.75rem;\n  border-top: 1px solid var(--theme-border, #e1e8ed);\n  padding-top: 0.75rem;\n"
    ]);
    _templateObject5 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _tagged_template_literal([
        "\n  color: #e0245e;\n  margin: 0.25rem 0;\n  font-size: 0.875rem;\n"
    ]);
    _templateObject6 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _tagged_template_literal([
        "\n  position: fixed;\n  top: ",
        "px;\n  left: ",
        "px;\n  background: var(--theme-surface, #fff);\n  border: 1px solid var(--theme-border, #e1e8ed);\n  border-radius: 8px;\n  box-shadow: 0 8px 30px rgba(0,0,0,0.12);\n  max-height: 240px;\n  overflow: auto;\n  z-index: 50;\n  min-width: 220px;\n"
    ]);
    _templateObject7 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _tagged_template_literal([
        "\n  padding: 8px 12px;\n  cursor: pointer;\n  &:hover {\n    background: var(--theme-background-secondary, #f7f9fa);\n  }\n"
    ]);
    _templateObject8 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = _tagged_template_literal([
        "\n  margin-top: 8px;\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 8px;\n"
    ]);
    _templateObject9 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = _tagged_template_literal([
        "\n  border: 1px solid var(--theme-border, #e1e8ed);\n  border-radius: 10px;\n  padding: 8px;\n  background: var(--theme-surface, #fff);\n"
    ]);
    _templateObject10 = function _templateObject() {
        return data;
    };
    return data;
}
import React, { useEffect, useMemo, useRef, useState } from "react";
import styled from "@emotion/styled";
import { Button } from "@edusense/shared-ui-kit";
import { Avatar, MediaPreview, LinkPreview } from "@edusense/entities-media";
import { TWEET_COMPOSER_TEST_IDS } from "@edusense/shared-constants";
import { Image as ImageIcon, ListChecks as PollIcon } from "lucide-react";
import { prepareSocialPostProps } from "../utils/tweetHelpers";
import { SocialPost } from "@edusense/features-social-post";
import { useTokenAutocomplete } from "../../../hooks/useTokenAutocomplete";
import { useLinkPreview } from "../../../hooks/useLinkPreview";
import { PollOptions } from "@edusense/widgets-poll-widget";
var Container = styled.div(_templateObject());
var Row = styled.div(_templateObject1());
var Profile = styled.div(_templateObject2());
var Content = styled.div(_templateObject3());
var StyledTextArea = styled.textarea(_templateObject4());
var Controls = styled.div(_templateObject5());
var ErrorMessage = styled.div(_templateObject6());
var SuggestionsBox = styled.div(_templateObject7(), function(p) {
    return p.top;
}, function(p) {
    return p.left;
});
var SuggestionItem = styled.div(_templateObject8());
var ProjectsContainer = styled.div(_templateObject9());
var ProjectCard = styled.div(_templateObject10());
export default function TweetComposerContent(param) {
    var showProfileImage = param.showProfileImage, user = param.user, placeholder = param.placeholder, autoFocus = param.autoFocus, isOpen = param.isOpen, _param_mode = param.mode, mode = _param_mode === void 0 ? 'tweet' : _param_mode, referenceTweet = param.referenceTweet, onSubmitAction = param.onSubmitAction, store = param.store, externalSetImages = param.externalSetImages;
    var inputRef = useRef(null);
    var text = store.text, setText = store.setText, media = store.media, setMedia = store.setMedia, pollOptions = store.pollOptions, setPollOptions = store.setPollOptions, pollDuration = store.pollDuration, setPollDuration = store.setPollDuration, isPollActive = store.isPollActive, setIsPollActive = store.setIsPollActive, projectPreviews = store.projectPreviews, setProjectPreviews = store.setProjectPreviews, openFileSelector = store.openFileSelector;
    var lastSyncedMediaRef = useRef(null);
    useEffect(function() {
        if (!externalSetImages) {
            return;
        }
        var previous = lastSyncedMediaRef.current;
        var hasChanged = !previous || previous.length !== media.length || previous.some(function(item, index) {
            var _media_index, _media_index1;
            return (item === null || item === void 0 ? void 0 : item.id) !== ((_media_index = media[index]) === null || _media_index === void 0 ? void 0 : _media_index.id) || (item === null || item === void 0 ? void 0 : item.url) !== ((_media_index1 = media[index]) === null || _media_index1 === void 0 ? void 0 : _media_index1.url);
        });
        if (!hasChanged) {
            return;
        }
        lastSyncedMediaRef.current = media;
        externalSetImages(media);
    }, [
        media,
        externalSetImages
    ]);
    var _useLinkPreview = useLinkPreview({
        text: text
    }), detectedUrl = _useLinkPreview.detectedUrl, linkPreviewData = _useLinkPreview.linkPreviewData;
    // 토큰 자동완성
    var _useTokenAutocomplete = useTokenAutocomplete({
        inputRef: inputRef,
        text: text,
        setText: setText,
        setProjectPreviews: setProjectPreviews
    }), suggestions = _useTokenAutocomplete.suggestions, suggestionsPosition = _useTokenAutocomplete.suggestionsPosition, detectTokenAndShowSuggestions = _useTokenAutocomplete.detectTokenAndShowSuggestions, handleTextChange = _useTokenAutocomplete.handleTextChange, handleSelectSuggestion = _useTokenAutocomplete.handleSelectSuggestion;
    // 제출 상태
    var _useState = _sliced_to_array(useState(false), 2), isSubmitting = _useState[0], setIsSubmitting = _useState[1];
    var characterCount = text.length;
    var isPollValid = function(options) {
        return options.filter(function(o) {
            return o.trim();
        }).length >= 2;
    };
    var isTweetButtonDisabled = isSubmitting || text.trim() === '' && media.length === 0 || characterCount > 280 || isPollActive && !isPollValid(pollOptions);
    var buttonText = useMemo(function() {
        if (mode === 'reply') return '답글';
        if (mode === 'quote') return '트윗';
        return '트윗';
    }, [
        mode
    ]);
    var placeholderText = placeholder || (mode === 'reply' ? '답글을 작성하세요…' : '무슨 일이 일어나고 있나요?');
    useEffect(function() {
        if (isOpen && autoFocus && inputRef.current) {
            setTimeout(function() {
                var _inputRef_current;
                return (_inputRef_current = inputRef.current) === null || _inputRef_current === void 0 ? void 0 : _inputRef_current.focus();
            }, 0);
        }
    }, [
        isOpen,
        autoFocus
    ]);
    // PollOptions 위젯 변환/반영
    var pollForWidget = useMemo(function() {
        if (!isPollActive) return null;
        var opts = (pollOptions.length ? pollOptions : [
            '',
            ''
        ]).map(function(t, i) {
            return {
                id: String(i + 1),
                text: t,
                votes: 0,
                percentage: 0
            };
        });
        return {
            id: 'new',
            options: opts,
            question: '',
            endTime: new Date(Date.now() + pollDuration * 60 * 60 * 1000)
        };
    }, [
        isPollActive,
        pollOptions,
        pollDuration
    ]);
    var setPollFromWidget = function(poll) {
        if (!poll) {
            setIsPollActive(false);
            setPollOptions([
                '',
                ''
            ]);
            setPollDuration(24);
            return;
        }
        var texts = (poll.options || []).map(function(o) {
            return o.text || '';
        }).slice(0, 4);
        if (texts.length < 2) texts.push('');
        setPollOptions(texts);
        if (poll.endTime) {
            var diffMs = new Date(poll.endTime).getTime() - Date.now();
            var hours = Math.max(1, Math.round(diffMs / 3600000));
            setPollDuration(hours);
        }
    };
    var handleRemoveMedia = function(index) {
        return setMedia(function(prev) {
            var next = prev.filter(function(_, i) {
                return i !== index;
            });
            if (externalSetImages) {
                externalSetImages(next);
            }
            return next;
        });
    };
    var handleRemoveProjectPreview = function(id) {
        return setProjectPreviews(function(prev) {
            return prev.filter(function(p) {
                return p.id !== id;
            });
        });
    };
    var handleTweetSubmit = /*#__PURE__*/ function() {
        var _ref = _async_to_generator(function() {
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!onSubmitAction) return [
                            2
                        ];
                        setIsSubmitting(true);
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            ,
                            3,
                            4
                        ]);
                        return [
                            4,
                            onSubmitAction(text)
                        ];
                    case 2:
                        _state.sent();
                        return [
                            3,
                            4
                        ];
                    case 3:
                        setIsSubmitting(false);
                        return [
                            7
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function handleTweetSubmit() {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ React.createElement(Container, {
        "data-testid": TWEET_COMPOSER_TEST_IDS.COMPOSER_CONTAINER
    }, /*#__PURE__*/ React.createElement(Row, null, showProfileImage && user && /*#__PURE__*/ React.createElement(Profile, null, /*#__PURE__*/ React.createElement(Avatar, {
        username: (user === null || user === void 0 ? void 0 : user.username) || '',
        name: user === null || user === void 0 ? void 0 : user.name,
        profileImage: user === null || user === void 0 ? void 0 : user.profileImage,
        size: "md"
    })), /*#__PURE__*/ React.createElement(Content, null, /*#__PURE__*/ React.createElement(StyledTextArea, {
        "data-testid": TWEET_COMPOSER_TEST_IDS.TEXTAREA,
        ref: inputRef,
        placeholder: placeholderText,
        value: text,
        onChange: handleTextChange,
        onKeyUp: detectTokenAndShowSuggestions,
        onClick: detectTokenAndShowSuggestions,
        rows: 1,
        maxLength: 280
    }), !!(suggestions === null || suggestions === void 0 ? void 0 : suggestions.length) && suggestionsPosition && /*#__PURE__*/ React.createElement(SuggestionsBox, {
        top: suggestionsPosition.top,
        left: suggestionsPosition.left
    }, suggestions.map(function(s, idx) {
        return /*#__PURE__*/ React.createElement(SuggestionItem, {
            key: idx,
            onClick: function() {
                return handleSelectSuggestion(s);
            }
        }, s.label);
    })), media.length > 0 && /*#__PURE__*/ React.createElement("div", {
        "data-testid": TWEET_COMPOSER_TEST_IDS.MEDIA_PREVIEW,
        style: {
            margin: '8px 0'
        }
    }, /*#__PURE__*/ React.createElement(MediaPreview, {
        media: media,
        onRemove: handleRemoveMedia,
        isSubmitting: isSubmitting
    })), projectPreviews.length > 0 && /*#__PURE__*/ React.createElement(ProjectsContainer, null, projectPreviews.map(function(p) {
        return /*#__PURE__*/ React.createElement(ProjectCard, {
            key: p.id
        }, /*#__PURE__*/ React.createElement("div", {
            style: {
                fontWeight: 700
            }
        }, p.title), p.description && /*#__PURE__*/ React.createElement("div", {
            style: {
                fontSize: 14,
                color: '#555'
            }
        }, p.description), /*#__PURE__*/ React.createElement("div", {
            style: {
                display: 'flex',
                justifyContent: 'flex-end',
                marginTop: 6
            }
        }, /*#__PURE__*/ React.createElement(Button, {
            size: "xs",
            variant: "ghost",
            onClick: function() {
                return handleRemoveProjectPreview(p.id);
            }
        }, "제거")));
    })), isPollActive && /*#__PURE__*/ React.createElement("div", {
        style: {
            margin: '8px 0'
        }
    }, /*#__PURE__*/ React.createElement(PollOptions, {
        poll: pollForWidget,
        setPoll: function(p) {
            return setPollFromWidget(p);
        },
        isSubmitting: isSubmitting
    })), mode === 'quote' && referenceTweet && /*#__PURE__*/ React.createElement("div", {
        style: {
            margin: '8px 0'
        }
    }, /*#__PURE__*/ React.createElement(SocialPost, _object_spread_props(_object_spread({}, prepareSocialPostProps(referenceTweet)), {
        className: "border border-gray-200 dark:border-gray-800 rounded-xl"
    }))), linkPreviewData && /*#__PURE__*/ React.createElement("div", {
        style: {
            margin: '8px 0'
        }
    }, /*#__PURE__*/ React.createElement(LinkPreview, {
        url: linkPreviewData.url,
        title: linkPreviewData.title,
        description: linkPreviewData.description,
        image: linkPreviewData.image,
        siteName: linkPreviewData.siteName,
        type: linkPreviewData.type
    })), characterCount > 280 && /*#__PURE__*/ React.createElement(ErrorMessage, null, "최대 280자를 초과할 수 없습니다."), /*#__PURE__*/ React.createElement(Controls, null, /*#__PURE__*/ React.createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: 8
        }
    }, /*#__PURE__*/ React.createElement(Button, {
        variant: "ghost",
        size: "sm",
        onClick: openFileSelector,
        leftIcon: /*#__PURE__*/ React.createElement(ImageIcon, {
            size: 16
        }),
        "data-testid": TWEET_COMPOSER_TEST_IDS.MEDIA_BUTTON
    }, "미디어"), /*#__PURE__*/ React.createElement(Button, {
        variant: isPollActive ? 'primary' : 'ghost',
        size: "sm",
        onClick: function() {
            return setIsPollActive(!isPollActive);
        },
        leftIcon: /*#__PURE__*/ React.createElement(PollIcon, {
            size: 16
        })
    }, "투표")), /*#__PURE__*/ React.createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: 12
        }
    }, /*#__PURE__*/ React.createElement("span", {
        "data-testid": TWEET_COMPOSER_TEST_IDS.CHARACTER_COUNT,
        style: {
            fontSize: 14,
            color: characterCount > 280 ? '#e0245e' : characterCount > 224 ? '#ffad1f' : '#657786'
        }
    }, characterCount, "/280"), /*#__PURE__*/ React.createElement(Button, {
        onClick: handleTweetSubmit,
        disabled: isTweetButtonDisabled,
        isLoading: isSubmitting,
        size: "sm",
        variant: "primary",
        "data-testid": TWEET_COMPOSER_TEST_IDS.SUBMIT_BUTTON
    }, buttonText))))));
}
